import useGalleryRendering from './fullscreenImages/hooks/useGalleryRendering';
import { SmallImages } from './smallImages/SmallImages';
import { FullscreenImages } from './fullscreenImages/FullscreenImages';
import { GalleryWidgetModel } from '../models/GalleryWidgetModel';
import { SmallMobileImages } from './smallImages/SmallMobileImages';

interface ImageGalleryProps {
  formData: GalleryWidgetModel;
}
/**
 * @description This component is the wrapper component for the ImageGallery. It displays the images and handles the full screen mode.
 * @param0 formData GalleryWidgetState; The data of the widget.
 * @returns {JSX.Element} The ImageGallery component
 */
export const ImageGallery = ({ formData }: ImageGalleryProps) => {
  const { isViewerOpen, viewerImageIndex, closeImageViewer, openImageViewer, showPreviousImage, showNextImage } = useGalleryRendering({
    formData,
  });
  const images = formData.images && formData.images[0] ? formData.images.slice(1) : [{ alt: '', fileName: '', url: '' }];
  const renderedImages = formData.renderedImages ? Number(formData.renderedImages) : 5;

  return (
    <div>
      <SmallImages openImageViewer={openImageViewer} images={images} renderedImages={renderedImages} />
      <SmallMobileImages openImageViewer={openImageViewer} images={images} renderedImages={renderedImages} />
      <FullscreenImages closeImageViewer={closeImageViewer} isViewerOpen={isViewerOpen} showNextImage={showNextImage} showPreviousImage={showPreviousImage} viewerImageIndex={viewerImageIndex} images={images} />
    </div>
  );
};
